import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from 'app/services/apis.service';
import { LoadingService } from 'app/services/loading.service';
import { environment } from 'environments/environment.staging';

@Component({
  selector: 'app-transfered-transactions',
  templateUrl: './transfered-transactions.component.html',
  styleUrls: ['./transfered-transactions.component.scss']
})
export class TransferedTransactionsComponent implements OnInit {
  public usersData: any = [];

  userId!: number;

  /**
   *
   * Variables
   *
   */
  public finance : any

  

  constructor(
    private apiService : ApisService , 
    private loading : LoadingService , 
    private router : Router,
        private apiservice: ApisService,
        private route: ActivatedRoute
  ) { }
 
  ngOnInit(): void {

  // ✅ Only subscribe to route params, don’t call getFinance() separately
  this.route.params.subscribe(params => {
    if (params['userId']) {
      this.userId = +params['userId']; // convert string → number
      this.getFinance(); // ✅ now called only when userId is ready
    }
  });
}

getFirstImage(postItem): string {

  console.log(postItem);
  return  postItem
  
    ? environment.mediaUrl + "/" + postItem
    // : "assets/images/logo/logo1.svg";
    : "assets/images/goalngo/profile.svg";

}


      // 🔹 Fetch Admin Dashboard Data
  getAdminDashboard(): void {
    this.apiservice.adminDashboard().subscribe({
      next: (response: any) => {
        this.usersData = response.data?.data?.personas || [];
        console.log("Admin Dashboard Data:", response);
      },
      error: (err) => {
        console.log("Error in fetching Data", err);
      },
    });
  }

    handleImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = "assets/images/goalngo/profile.svg"; // Fallback image
  }


  

    /*----------  Get Finance  ----------*/
    getFinance() {
      this.loading.show() 
      this.apiService.transferedTransactions(this.userId).subscribe({
        next: (response: any) => {
          this.finance = response.data?.items
          this.loading.hide()
          console.log("response" , response);
        }, 
        error:(err) => {
          this.loading.hide()
          console.log("error in fetching data", err);
        },
      })
    }
 
    
    
    /*----------  Navigate to transaction page  ----------*/
    navigateToTransaction(id : any) {
      this.router.navigate(['/accouting/user' , id , 'transactions'] , {state : {receivedOnly : true}});
    }
    
}
